module.exports = __webpack_public_path__ + "6c186980284acd6265231bef006ffd97.png";